<template>
  <div class="chart" v-if="isRouterAlive">
    <div class="YearLine" v-if="eChars.Pub_Time">
      <div class="yearsTitle">
        <h3>发布年份</h3>
        <el-button-group>
          <el-button
            @click="yearsPick('five')"
            :class="vintages ? 'threePick' : 'fivePick'"
            >五年内</el-button
          >
          <el-button
            @click="yearsPick('three')"
            :class="vintages ? 'fivePick' : 'threePick'"
            >三年内</el-button
          >
        </el-button-group>
      </div>
      <el-divider></el-divider>
      <div class="Echarts">
        <div id="main" style="width: 100%; height: 400px"></div>
      </div>
    </div>
    <div class="procedural">
      <!-- <div class="trial">
        <div class="trialTitle">
          <h3>专题分类</h3>
        </div>
        <el-divider></el-divider>
        <div id="trialBar" style="width: 100%; height: 400px"></div>
      </div> -->
      <div class="paperwork" v-if="eChars.Timeliness">
        <div class="trialTitle">
          <h3>时效性</h3>
        </div>
        <el-divider></el-divider>
        <div id="paperworkPie" style="width: 100%; height: 400px"></div>
      </div>
      <div class="brief" v-if="eChars.Eff_level">
        <div class="trialTitle">
          <h3>效力级别</h3>
        </div>
        <el-divider></el-divider>
        <div id="briefPie" style="width: 100%; height: 400px"></div>
      </div>
    </div>
    <div class="procedural">
      <div class="paperwork" v-if="eChars.Pub_Department && eChars.Pub_Department.length <= 5">
        <div class="trialTitle">
          <h3>发布部门</h3>
        </div>
        <el-divider></el-divider>
        <div id="departmentPie" style="width: 100%; height: 400px"></div>
      </div>
      <div class="brief" v-if="eChars.Doc_Category">
        <div class="trialTitle">
          <h3>文书分类</h3>
        </div>
        <el-divider></el-divider>
        <div id="paperworkPie" style="width: 100%; height: 400px"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["eChars"],
  //   inject: ["reloadCharts"],
  data() {
    return {
      isRouterAlive: true,
      timeLine: [],
      timeYears: [],
      timeCount: [],
      vintages: false,
      trialCount: [],
      trialKey: [],
      paperCharts: [], //有效性 可视化数据
      // briefChart: [], //效力级别 可视化数据
      briefKey: [],
      briefCount: [],
      departmentChart: [],
      departmentKey: [],
      departmentCount: [],
      CategoryChart: [],
      CategoryKey: [],
      CategoryCount: [],
    };
  },
  created() {
    // console.log(this.eChars);
    this.timeYears = []; //年份
    this.timeCount = []; //年份发布量
    if (this.eChars.Pub_Time) {
      this.timeLine = this.eChars.Pub_Time;
      this.timeLine
        .slice(0, 5)
        .reverse()
        .forEach((item) => {
          this.timeYears.push(item.key_as_string);
          this.timeCount.push(item.doc_count);
        });
    }
    this.trialCount = [];
    this.trialKey = [];
    if (this.eChars.Thematic) {
      this.eChars.Thematic.forEach((item) => {
        this.trialCount.push(item.count);
        this.trialKey.push(item.name);
      });
    }

    // 时效性
    this.paperCharts = [];
    if (this.eChars.Timeliness) {
      this.eChars.Timeliness.forEach((item) => {
        let paper = {
          value: item.doc_count,
          name: item.key,
        };
        this.paperCharts.push(paper);
      });
    }

    // 效力级别
    this.briefChart = [];
    if (this.eChars.Eff_level) {
      this.eChars.Eff_level.forEach((item) => {
        this.briefCount.push(item.count);
        this.briefKey.push(item.name);
        // let cause = {
        //   value: item.count,
        //   name: item.name,
        // };
        // this.briefChart.push(cause);
      });
    }
    // 发布部门
    this.departmentChart = [];
    if (this.eChars.Pub_Department) {
      this.eChars.Pub_Department.forEach((item) => {
        // this.departmentCount.push(item.count);
        // this.departmentKey.push(item.name);
        let department = {
          value: item.count,
          name: item.name,
        };
        this.departmentChart.push(department);
      });
    }
    // 文书类型
    this.CategoryChart = [];
    if (this.eChars.Doc_Category) {
      this.eChars.Doc_Category.forEach((item) => {
        // this.CategoryCount.push(item.count);
        // this.CategoryKey.push(item.name);
        let Category = {
          value: item.count,
          name: item.name,
        };
        this.CategoryChart.push(Category);
      });
    }
    // console.log(this.CategoryChart);
  },
  methods: {
    // 发布年份
    myEcharts() {
      if (this.eChars.Pub_Time) {
        var myChart = this.$echarts.init(
          window.document.getElementById("main")
        );
        //配置图表
        var option = {
          title: {
            text: "",
          },
          tooltip: {},
          legend: {
            data: [""],
          },
          xAxis: {
            data: this.timeYears,
          },
          yAxis: {},
          series: [
            {
              name: "时间",
              type: "bar",

              itemStyle: {
                normal: {
                  color: "#f99362", //改变折线点的颜色
                  lineStyle: {
                    color: "#f99362", //改变折线颜色
                  },
                },
              },
              data: this.timeCount,
              showBackground: true,

              barMaxWidth: 30, // 最大宽度
              label: {
                //设置柱状图上显示  对应值
                show: true,
                position: "top",
                color: "#606266",
              },
            },
            {
              name: "时间",
              type: "line",

              itemStyle: {
                normal: {
                  color: "#f99362", //改变折线点的颜色
                  lineStyle: {
                    color: "#f99362", //改变折线颜色
                  },
                },
              },
              data: this.timeCount,
              showBackground: true,
              barMaxWidth: 30, // 最大宽度
            },
          ],
        };
        myChart.setOption(option);
      }
    },
    // 折线展示年份
    yearsPick(year) {
      if (year == "five") {
        if (this.vintages == true) {
          //   console.log("5");
          this.timeYears = [];
          this.timeCount = [];
          this.eChars.Pub_Time.slice(0, 5)
            .reverse()
            .forEach((item) => {
              this.timeYears.push(item.key_as_string);
              this.timeCount.push(item.doc_count);
            });
          this.vintages = false;
          this.myEcharts();
        }
      }
      if (year == "three") {
        if (this.vintages == false) {
          //   console.log("3");
          this.timeYears = [];
          this.timeCount = [];
          this.eChars.Pub_Time.slice(0, 3)
            .reverse()
            .forEach((item) => {
              this.timeYears.push(item.key_as_string);
              this.timeCount.push(item.doc_count);
            });
          this.vintages = true;
          this.myEcharts();
        }
      }
    },

    // 专题分类
    myTrials() {
      var myTrial = this.$echarts.init(
        window.document.getElementById("trialBar")
      );
      //配置图表
      var option = {
        title: {
          // text: "专题分类",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        // grid: {
        //   left: "3%",
        //   right: "4%",
        //   bottom: "3%",
        //   containLabel: true,
        // },
        // tooltip: {
        //   trigger: "axis",
        //   axisPointer: {
        //     type: "shadow",
        //   },
        // },
        grid: {
          x: 110,
          y: 0,
          x2: 50,
          y2: 0,
          borderWidth: 1,
        },
        xAxis: {
          show: false,
          type: "value",
          splitLine: {
            show: false,
          },

          boundaryGap: [0, 0.5],
          //   position: "top",
          //   splitLine: {
          //     show: true,
          //   },
          //   axisLine: {
          //     //x轴坐标轴
          //     show: false,
          //   },
          //   axisLabel: {
          //     show: false,
          //   },
          //   axisTick: {
          //     //x轴刻度线
          //     show: false,
          //   },
        },
        yAxis: {
          show: true,
          boundaryGap: true,
          type: "category",
          data: this.trialKey,
          boundaryGap: [0, 0.5],
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            data: this.trialCount,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 10, // 最大宽度
            barGap: "20px" /*多个并排柱子设置柱子之间的间距*/,
            barCategoryGap: "20px" /*多个并排柱子设置柱子之间的间距*/,
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
            },
            barWidth: 10,
            itemStyle: {
              emphasis: {
                barBorderRadius: 5,
              },
              // normal: {
              //   barBorderRadius: 7,
              // },
              normal: {
                barBorderRadius: 5,
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  // new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  //   { offset: 0, color: "#3977E6" },
                  //   { offset: 1, color: "#37BBF8" },
                  // ]);
                  if (djg > 8) {
                    retcoler = "#ef6b59";
                  }
                  if (djg > 2 && djg < 8) {
                    retcoler = "#56c9f7";
                  }
                  return retcoler;
                },

                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      myTrial.setOption(option);
      const autoHeight = this.trialKey.length * (10 + 12); // 柱状图的每个item的间距是28,10是每个item的宽度,keyData.length是item的总数
      myTrial.resize({ height: autoHeight });
    },
    // 有效性
    myPaperwork() {
      if (this.eChars.Timeliness) {
        var myPaper = this.$echarts.init(
          window.document.getElementById("paperworkPie")
        );
        var option = {
          title: {
            //   text: "Referer of a Website",
            //   subtext: "Fake Data",
            //   left: "center",
          },
          tooltip: {
            trigger: "item",
          },
          legend: {
            orient: "vertical",
            left: "right",
          },
          series: [
            {
              // name: "Access From",
              type: "pie",
              radius: ["40%", "70%"],
              label: {
                normal: {
                  // show: true,
                  // position: 'inside',
                  formatter: "{b}({d}%)", //模板变量有 {a}、{b}、{c}、{d}，分别表示系列名，数据名，数据值，百分比。{d}数据会根据value值计算百分比
                },
              },
              data: this.paperCharts,
              // emphasis: {
              //   itemStyle: {
              //     shadowBlur: 10,
              //     shadowOffsetX: 0,
              //     shadowColor: "rgba(0, 0, 0, 0.5)",
              //   },
              // },
            },
          ],
        };
        myPaper.setOption(option);
      }
    },
    // 效力级别
    myBriefs() {
      if (this.eChars.Eff_level) {
        var myBrief = this.$echarts.init(
          window.document.getElementById("briefPie")
        );
        var option = {
          title: {
            // text: "专题分类",
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          // grid: {
          //   left: "3%",
          //   right: "4%",
          //   bottom: "3%",
          //   containLabel: true,
          // },
          // tooltip: {
          //   trigger: "axis",
          //   axisPointer: {
          //     type: "shadow",
          //   },
          // },
          grid: {
            x: 110,
            y: 0,
            x2: 50,
            y2: 0,
            borderWidth: 1,
          },
          xAxis: {
            show: false,
            type: "value",
            splitLine: {
              show: false,
            },

            boundaryGap: [0, 0.5],
            //   position: "top",
            //   splitLine: {
            //     show: true,
            //   },
            //   axisLine: {
            //     //x轴坐标轴
            //     show: false,
            //   },
            //   axisLabel: {
            //     show: false,
            //   },
            //   axisTick: {
            //     //x轴刻度线
            //     show: false,
            //   },
          },
          yAxis: {
            show: true,
            boundaryGap: true,
            type: "category",
            data: this.briefKey,
            boundaryGap: [0, 0.5],
            axisLine: {
              //y轴
              show: false,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            splitLine: {
              //网格线
              show: false,
            },
          },
          series: [
            {
              type: "bar",
              data: this.briefCount,
              showBackground: true,
              backgroundStyle: {
                color: "rgba(180, 180, 180, 0.2)",
              },
              // barWidth: 30, // 柱图宽度
              barMaxWidth: 10, // 最大宽度
              barGap: "20px" /*多个并排柱子设置柱子之间的间距*/,
              barCategoryGap: "20px" /*多个并排柱子设置柱子之间的间距*/,
              label: {
                //设置柱状图上显示  对应值
                show: true,
                position: "right",
                color: "#606266",
              },
              barWidth: 10,
              itemStyle: {
                emphasis: {
                  barBorderRadius: 5,
                },
                // normal: {
                //   barBorderRadius: 7,
                // },
                normal: {
                  barBorderRadius: 5,
                  color: function (params) {
                    // 设置前三个颜色不一样
                    var num = params.value;
                    var djg = params.dataIndex; //第几个数
                    var retcoler = "#345edc";
                    // new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    //   { offset: 0, color: "#3977E6" },
                    //   { offset: 1, color: "#37BBF8" },
                    // ]);
                    if (djg > 8) {
                      retcoler = "#ef6b59";
                    }
                    if (djg > 2 && djg < 8) {
                      retcoler = "#56c9f7";
                    }
                    return retcoler;
                  },

                  // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
                },
              },
            },
          ],
        };
        myBrief.setOption(option);
      }
    },
    // 发布部门
    myDepartment() {
      if (this.eChars.Pub_Department && this.eChars.Pub_Department.length <= 5) {
        var myDepart = this.$echarts.init(
          window.document.getElementById("departmentPie")
        );
        var option = {
          title: {
            //   text: "Referer of a Website",
            //   subtext: "Fake Data",
            //   left: "center",
          },
          tooltip: {
            trigger: "item",
          },
          legend: {
            orient: "vertical",
            left: "right",
          },
          series: [
            {
              // name: "Access From",
              type: "pie",
              radius: ["40%", "70%"],
              label: {
                normal: {
                  // show: true,
                  // position: 'inside',
                  formatter: "{b}({d}%)", //模板变量有 {a}、{b}、{c}、{d}，分别表示系列名，数据名，数据值，百分比。{d}数据会根据value值计算百分比
                },
              },
              data: this.departmentChart,
              // emphasis: {
              //   itemStyle: {
              //     shadowBlur: 10,
              //     shadowOffsetX: 0,
              //     shadowColor: "rgba(0, 0, 0, 0.5)",
              //   },
              // },
            },
          ],
        };
        myDepart.setOption(option);
      }
    },
    // 文书分类
    myCategory() {
      if (this.eChars.Doc_Category) {
        var myPaperwork = this.$echarts.init(
          window.document.getElementById("paperworkPie")
        );
        var option = {
          title: {
            //   text: "Referer of a Website",
            //   subtext: "Fake Data",
            //   left: "center",
          },
          tooltip: {
            trigger: "item",
          },
          legend: {
            orient: "vertical",
            left: "right",
          },
          series: [
            {
              // name: "Access From",
              type: "pie",
              radius: ["40%", "70%"],
              label: {
                normal: {
                  // show: true,
                  // position: 'inside',
                  formatter: "{b}({d}%)", //模板变量有 {a}、{b}、{c}、{d}，分别表示系列名，数据名，数据值，百分比。{d}数据会根据value值计算百分比
                },
              },
              data: this.CategoryChart,
              // emphasis: {
              //   itemStyle: {
              //     shadowBlur: 10,
              //     shadowOffsetX: 0,
              //     shadowColor: "rgba(0, 0, 0, 0.5)",
              //   },
              // },
            },
          ],
        };
        myPaperwork.setOption(option);
      }
    },
  },
  watch: {
    eChars(val) {
      this.dataCharts = val;
    },
  },
  mounted() {
    this.myEcharts(); // 发布年份
    // this.myTrials(); // 专题分类
    this.myPaperwork(); // 时效性
    this.myBriefs(); // 效力级别
    // this.myLevel();
    this.myDepartment(); // 发布部门
    this.myCategory(); // 文书分类
  },
};
</script>

<style  lang="less" scoped>
.chart {
  .caseType {
    display: flex;
    justify-content: space-around;
    margin: 10px 0;
    // background: white;
    background: #fbf2eb;
    padding: 10px 0;
    border-radius: 10px;
    .case {
      width: 120px;
      p {
        text-align: center;
      }
      img {
        width: 50px;
        margin: 10px 35px;
      }
    }
  }
  .YearLine {
    // background: white;
    background: #fbf2eb;
    padding: 10px 50px;
    border-radius: 10px;
    .yearsTitle {
      display: flex;
      justify-content: space-between;
     h3 {
        display: inline-block;
        font-size: 18px;
        font-weight: 600;
        line-height: 40px;
      }
      .fivePick {
        // color: #409eff;
        // background: #ecf5ff;
        // border-color: #b3d8ff;
         color: #ddb361;
        background: #faf1ea;
        border-color: #ddb361;
      }
      .threePick {
        // background: #fff;
        // border: 1px solid #dcdfe6;
        // color: #606266;
          // color: #ddb361;
         background: none !important;
          border: 1px solid #c0bbb0;
      }
      .el-button:hover {
        // color: #409eff;
        // border-color: #c6e2ff;
        // background-color: #ecf5ff;
        color: #ddb361;
        background: #faf1ea;
        border-color: #ddb361;
      }
    }
  }
  .procedural {
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
    .trial,
    .paperwork,
    .reference,
    .brief {
      width: 48%;
      // background: white;
      background: #fbf2eb;
      padding: 10px 10px;
      border-radius: 10px;
    }
  }
  .bid {
     // background: white;
      background: #fbf2eb;
    padding: 10px 10px;
    border-radius: 10px;
    margin: 0 0 20px 0;
  }
}
/deep/ .el-divider--horizontal {
  margin: 10px 0;
  color: #e7f7a4;
}
.trialTitle {
  display: flex;
  justify-content: space-between;
  h3 {
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    line-height: 40px;
  }
  img {
    width: 24px;
    margin: 8px;
    cursor: pointer;
    transition: all 0.6s;
  }
  img:hover {
    transform: scale(1.4);
  }
  .zhu {
    width: 100%;
    height: 400px;
  }
  .zhe {
    width: 0;
    height: 0;
  }
}
#paperworkPie01 {
  // position: relative;
  // top: -400px;
  // z-index: 100000000;
 
}
</style>